// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"portal-app_qrCode__2PFBq","desktop":"portal-app_desktop__2NSKH","qr":"portal-app_qr__b_5G0","mobile":"portal-app_mobile__23dRb"};